import React from 'react';
import {
    Box,
    Button,
    Card,
    Chip,
    CircularProgress,
    IconButton,
    Tooltip,
    Typography,
} from "@mui/material";
import {
    CalendarTodayRounded,
    DeleteOutlineRounded,
    PaymentRounded,
    PictureAsPdfRounded,
} from "@mui/icons-material";
import { getUserFixedName, toPriceWithComma } from "../../../helper/utils";

const _InvoiceCardItem = ({
    row,
    isDownloading,
    onDownloadPdf,
    onPay,
    onCancel,
}) => {
    const serialShort = row.Serial?.Serial ? row.Serial.Serial.split("-")[0] : row.Serial;

    return (
        <Card
            variant="outlined"
            sx={{
                p: 2,
                borderRadius: 3,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : 'rgba(0, 0, 0, 0.01)',
                transition: 'all 0.2s ease',
                '&:hover': {
                    borderColor: 'primary.main',
                    boxShadow: '0 4px 14px rgba(28, 139, 156, 0.08)'
                }
            }}
        >
            {/* Card Top Row: Date, Serial, Delete */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Chip
                        label={`شناسه: ${serialShort}`}
                        size="small"
                        variant="outlined"
                        sx={{ borderRadius: 1.5, fontWeight: 700, fontSize: '0.72rem' }}
                    />
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary' }}>
                        <CalendarTodayRounded sx={{ fontSize: 13 }} />
                        <Typography variant="caption">
                            {new Date(row.CreatedDate).toLocaleDateString('fa-IR', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric'
                            })}
                        </Typography>
                    </Box>
                </Box>

                <Tooltip title="لغو و حذف پیش‌فاکتور">
                    <IconButton
                        size="small"
                        color="error"
                        onClick={() => onCancel(row)}
                        sx={{
                            bgcolor: 'rgba(239, 68, 68, 0.06)',
                            '&:hover': { bgcolor: 'error.main', color: 'white' }
                        }}
                    >
                        <DeleteOutlineRounded fontSize="small" />
                    </IconButton>
                </Tooltip>
            </Box>

            {/* Amount & Creator */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Box>
                    <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
                        مبلغ شارژ:
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 900, color: 'text.primary' }}>
                        {toPriceWithComma(row.Amount)}
                        <Typography component="span" variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, mr: 0.5 }}>
                            تومان
                        </Typography>
                    </Typography>
                </Box>

                {row?.CreatorUser && (
                    <Typography variant="caption" sx={{ color: 'text.secondary', bgcolor: 'action.hover', px: 1, py: 0.5, borderRadius: 1.5 }}>
                        توسط: {getUserFixedName(row.CreatorUser)}
                    </Typography>
                )}
            </Box>

            {/* Action Buttons */}
            <Box sx={{ display: 'flex', gap: 1.2 }}>
                <Button
                    variant="outlined"
                    size="small"
                    fullWidth
                    disabled={isDownloading}
                    startIcon={isDownloading ? <CircularProgress size={16} /> : <PictureAsPdfRounded sx={{ ml: 0.5 }} />}
                    onClick={() => onDownloadPdf(row)}
                    sx={{ borderRadius: 2.2, fontWeight: 700, fontSize: '0.8rem' }}
                >
                    دانلود PDF
                </Button>
                <Button
                    variant="contained"
                    size="small"
                    fullWidth
                    startIcon={<PaymentRounded sx={{ ml: 0.5 }} />}
                    onClick={() => onPay(row)}
                    sx={{
                        borderRadius: 2.2,
                        fontWeight: 700,
                        fontSize: '0.8rem',
                        boxShadow: '0 4px 12px rgba(28, 139, 156, 0.2)'
                    }}
                >
                    تکمیل پرداخت
                </Button>
            </Box>
        </Card>
    );
};

export default _InvoiceCardItem;
